import React from "react";

function Facebook() {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
      width="45"
      height="45"
      viewBox="0 0 256 256"
      className="facebook"
    >
      <path
        fill="rgb(84 124 164)"
        d="M83.254 90H59.253a2 2 0 01-2-2V54.696a2 2 0 012-2h9.42l1.158-8.979H59.253a2 2 0 01-2-2v-8.286c0-3.571.874-8.319 8.432-8.319l4.873-.002v-7.801c-1.871-.154-4.797-.32-8.015-.32-9.2 0-14.693 5.666-14.693 15.156v9.572a2 2 0 01-2 2h-9.208v8.979h9.208a2 2 0 012 2V88a2 2 0 01-2 2H6.747A6.754 6.754 0 010 83.253V6.747A6.754 6.754 0 016.747 0h76.507A6.754 6.754 0 0190 6.747v76.506A6.754 6.754 0 0183.254 90zm-22.001-4h22.001A2.749 2.749 0 0086 83.253V6.747A2.749 2.749 0 0083.254 4H6.747A2.75 2.75 0 004 6.747v76.506A2.75 2.75 0 006.747 86H43.85V56.696h-9.208a2 2 0 01-2-2V41.717a2 2 0 012-2h9.208v-7.572c0-11.816 7.163-19.156 18.693-19.156 4.763 0 8.981.356 10.278.529a2 2 0 011.736 1.982v11.608a2 2 0 01-1.999 2l-6.873.003c-3.995 0-4.433 1.383-4.433 4.319v6.286h10.853a1.997 1.997 0 011.983 2.256l-1.674 12.979a2 2 0 01-1.983 1.744h-9.179V86z"
        transform="matrix(2.81 0 0 2.81 1.407 1.407)"
      ></path>
    </svg>
  );
}

export default Facebook;